import { defineNuxtPlugin } from '#imports';
import { logError } from '~/api';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = logError;
});
